export default "__VITE_ASSET__B_15SmXP__"